import React from "react";
import "../../styles/OwnerTrainingSummaryList.css";

const OwnerTrainingSummaryList = ({ summaries }) => {
    if (!summaries || !Array.isArray(summaries) || summaries.length === 0) {
        return (
            <div className="owner-training-summary-list">
                <div className="owner-empty-state">
                    <p className="owner-empty-text">Brak dostępnych zaleceń.</p>
                    <img src="/petboard-empty.png" alt="No recommendations" className="owner-empty-image" />
                </div>
            </div>
        );
    }

    return (
        <div className="owner-training-summary-list">
            <div className="owner-summary-list">
                {summaries.map((summary) => (
                    <div key={summary.id} className="owner-training-summary-item">
                        <div className="owner-summary-header">
                            <div className="owner-summary-header-left">
                                <p className="owner-summary-date">{new Date(summary.createTime).toLocaleDateString()}</p>
                                <p className="owner-summary-trainer">{summary.trainerName}</p>
                            </div>
                        </div>
                        <div className="owner-summary-content">
                            <div className="owner-summary-section">
                                <p className="owner-section-title">Podsumowanie</p>
                                <p className="owner-section-text">{summary.summary}</p>
                            </div>
                            <div className="owner-summary-section">
                                <p className="owner-section-title">Zalecenia</p>
                                <p className="owner-section-text">{summary.recommendations}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OwnerTrainingSummaryList;